module App.Classes {
    export class Time implements Interfaces.ITime {
        time: string;
        available: number;
    }
}